// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .customer-administrator-invoices-page{
        margin: 0px;
        padding: 0px;
        height: 100vh;
        box-sizing: border-box;
        font-family:Verdana, Geneva, Tahoma, sans-serif;
    }
    .customer-administrator-invoices-page-layout{
        height: 90%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .customer-administrator-invoices-parent-container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .customer-administrator-invoices-container{
        width: 90%;
        height: 85%;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
        padding: 2% 3%;
        border-radius: 5px;
        position: relative;
    }
    .customer-administrator-invoices-header-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .customer-administrator-invoices-header-container h2{
        font-weight: lighter;
        color: rgb(90, 90, 90);
    }
    .customer-administrator-invoices-header-controls{
        display: flex;
        align-items: center;
    }
    .customer-administrator-refresh-invoices-button{
        background-color: transparent;
        border: none;
        cursor: pointer;
        border-radius: 50%;
        padding: 5px 7px;
    }
    .customer-administrator-refresh-invoices-button:hover{
        background-color: rgb(214, 214, 214);
    }
    .customer-administrator-refresh-invoices-button img{
        height: 25px;
    }
    .customer-administrator-invoices-table-container{
        overflow: auto;
        max-height: 71.5vh;
        box-sizing: border-box;
    }
    .customer-administrator-invoices-table-container::-webkit-scrollbar{
        width: 4px;
    }
    .customer-administrator-invoices-table-container::-webkit-scrollbar-thumb{
        border-radius: 5px;
        background-color: rgba(0, 0, 0, 0.3);
    }
    .customer-administrator-invoices-table{
        width: 100%;
        border-collapse: collapse;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
    }
    .customer-administrator-invoices-table th,
    .customer-administrator-invoices-table td{
        text-align: left;
        padding: 10px 5px;
        white-space: nowrap;
    }
    .customer-administrator-invoices-table th{
        font-weight: 600;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .customer-administrator-invoices-table td{
        font-size: 12px;
    }
    #customer-administrator-invoices-header-row{
        color: black;
        background-color: transparent;
    }
    .customer-administrator-invoices-table tr:nth-child(even){
        cursor: pointer;
        background-color: rgb(242, 242, 242);
    }
    .customer-administrator-invoices-table tr:nth-child(odd){
        cursor: pointer;
        background-color: rgba(206, 206, 206, 0.952);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/CustomerAdministratorStyles/Invoices/Invoices.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,+CAA+C;IACnD;IACA;QACI,WAAW;QACX,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,UAAU;QACV,WAAW;QACX,sCAAsC;QACtC,cAAc;QACd,kBAAkB;QAClB,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;IACA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,6BAA6B;QAC7B,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,oCAAoC;IACxC;IACA;QACI,YAAY;IAChB;IACA;QACI,cAAc;QACd,kBAAkB;QAClB,sBAAsB;IAC1B;IACA;QACI,UAAU;IACd;IACA;QACI,kBAAkB;QAClB,oCAAoC;IACxC;IACA;QACI,WAAW;QACX,yBAAyB;QACzB,sCAAsC;IAC1C;IACA;;QAEI,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,gBAAgB;QAChB,4DAA4D;IAChE;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,6BAA6B;IACjC;IACA;QACI,eAAe;QACf,oCAAoC;IACxC;IACA;QACI,eAAe;QACf,4CAA4C;IAChD;AACJ","sourcesContent":["@media screen and (min-width:950px){\n    .customer-administrator-invoices-page{\n        margin: 0px;\n        padding: 0px;\n        height: 100vh;\n        box-sizing: border-box;\n        font-family:Verdana, Geneva, Tahoma, sans-serif;\n    }\n    .customer-administrator-invoices-page-layout{\n        height: 90%;\n        box-sizing: border-box;\n        display: grid;\n        grid-template-columns: auto 1fr;\n    }\n    .customer-administrator-invoices-parent-container{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .customer-administrator-invoices-container{\n        width: 90%;\n        height: 85%;\n        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\n        padding: 2% 3%;\n        border-radius: 5px;\n        position: relative;\n    }\n    .customer-administrator-invoices-header-container{\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n    .customer-administrator-invoices-header-container h2{\n        font-weight: lighter;\n        color: rgb(90, 90, 90);\n    }\n    .customer-administrator-invoices-header-controls{\n        display: flex;\n        align-items: center;\n    }\n    .customer-administrator-refresh-invoices-button{\n        background-color: transparent;\n        border: none;\n        cursor: pointer;\n        border-radius: 50%;\n        padding: 5px 7px;\n    }\n    .customer-administrator-refresh-invoices-button:hover{\n        background-color: rgb(214, 214, 214);\n    }\n    .customer-administrator-refresh-invoices-button img{\n        height: 25px;\n    }\n    .customer-administrator-invoices-table-container{\n        overflow: auto;\n        max-height: 71.5vh;\n        box-sizing: border-box;\n    }\n    .customer-administrator-invoices-table-container::-webkit-scrollbar{\n        width: 4px;\n    }\n    .customer-administrator-invoices-table-container::-webkit-scrollbar-thumb{\n        border-radius: 5px;\n        background-color: rgba(0, 0, 0, 0.3);\n    }\n    .customer-administrator-invoices-table{\n        width: 100%;\n        border-collapse: collapse;\n        box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n    }\n    .customer-administrator-invoices-table th,\n    .customer-administrator-invoices-table td{\n        text-align: left;\n        padding: 10px 5px;\n        white-space: nowrap;\n    }\n    .customer-administrator-invoices-table th{\n        font-weight: 600;\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n    .customer-administrator-invoices-table td{\n        font-size: 12px;\n    }\n    #customer-administrator-invoices-header-row{\n        color: black;\n        background-color: transparent;\n    }\n    .customer-administrator-invoices-table tr:nth-child(even){\n        cursor: pointer;\n        background-color: rgb(242, 242, 242);\n    }\n    .customer-administrator-invoices-table tr:nth-child(odd){\n        cursor: pointer;\n        background-color: rgba(206, 206, 206, 0.952);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
